import React, { useState, useEffect } from "react";
import Select from "react-select";

import API from '../../tools/API';
import styles from './Modal.module.scss';
import { singleTag, Tag, Option } from '../../tools/interfaces';

interface EditOption {
    data: {
        title: string,
        artist: string,
        image: string,
        file: string,
        content: string,
        id: number,
        smsCode: string,
        order: number,
        tagId: number
    }
    openModal: (arg: boolean) => void;
    pollId: string | undefined;
    tagList: Array<singleTag>;
    setOptions: (arg: []) => void
}

const customStyles = {
    indicatorsContainer: () => ({
        backgroundColor: '#e10626',
        borderRadius: '50%',
        marginLeft: '30px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }),
    control: () => ({
        display: 'flex',
        padding: '5px 13px 5px 13px',
        backgroundColor: '#eff1f6',
        border: '1px solid #cacaca',
        borderRadius: '20px',
        fontSize: '18px',
        fontWeight: '500',
        color: '#555454'
    }),
    dropdownIndicator: () => ({
        color: 'white',
        padding: '5px 7px',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer'
    }),
    indicatorSeparator: () => ({
        display: 'none'
    })
}

const EditOptionModal: React.FC<EditOption> = ({ data, openModal, pollId, tagList, setOptions }) => {
    const [selectedTag, setSelectedTag] = useState<Tag | null>({
        value: '',
        label: 'Bez tagu'
    });
    const [tagArr, setTagArr] = useState<Array<Tag>>([]);
    const [error, setError] = useState<string | null>(null);
    const [option, setOption] = useState<Option>(
        {
            id: data.id,
            content: data.content,
            file: data.file,
            image: data.image,
            artist: data.artist,
            title: data.title,
            pollId: parseInt(pollId as string),
            tagId: data.tagId,
            smsCode: data.smsCode,
            order: data.order
        }
    );
    const [loading, setLoading] = useState<boolean>(false);

    console.log(option);

    useEffect(() => {
        API.getPollOption(parseInt(pollId as string), data.id).then((res) => {
            setOption(res?.data.data);
        })
        if (tagList) {
            const mappedTagList = tagList.map((el: singleTag) => {
                return (
                    {
                        value: el.id,
                        label: el.name
                    }
                )
            })
            mappedTagList.push({
                value: '',
                label: 'Bez tagu'
            })
            setTagArr(mappedTagList);
            setSelectedTag(mappedTagList.filter((x: Tag) => x.value === option.tagId)[0])
        }
    }, []);

    const editOption = () => {

        const formdata = new FormData();

        let tagId = selectedTag?.value;

        formdata.append('Id', String(option.id));
        formdata.append('Content', option.content === null ? "" : option.content);
        formdata.append('Image', option.image);
        formdata.append('Artist', option.artist);
        formdata.append('Title', option.title);
        formdata.append('PollId', String(pollId));
        formdata.append('TagId', String(tagId));
        formdata.append('SmsCode', option.smsCode === null ? "" : option.smsCode);
        formdata.append('File', option.file);

        if (selectedTag) {
            API.editOption(formdata)
                .then(res => {
                    API.getListOfPollOptions(pollId).then((res) => {
                        setOptions(res?.data.data);
                    })
                    openModal(false);
                    setLoading(false);
                })
                .catch(err => {
                    setLoading(false);
                    setError(err.response.data.Exception);
                })
        } else {
            setLoading(false);
            setError("Wybierz tag!");
        }

    }

    return (
        <div className={styles.AddCathegory}>
            <h2 className={styles.AddCathegory__title} >Edytuj opcję</h2>
            <form className={styles.AddCathegory__form}>
                <input
                    type="text"
                    id="artist"
                    placeholder="Wykonawca"
                    className={styles.AddCathegory__formInput}
                    value={option.artist}
                    onChange={(e) => {
                        setOption({ ...option, artist: e.target.value })
                    }}
                />
                <input
                    type="text"
                    id="title"
                    placeholder="Tytuł"
                    className={styles.AddCathegory__formInput}
                    value={option.title}
                    onChange={(e) => {
                        setOption({ ...option, title: e.target.value })
                    }}
                />
                <input
                    type="text"
                    id="content"
                    placeholder="Opis"
                    className={styles.AddCathegory__formInput}
                    value={option.content}
                    onChange={(e) => {
                        setOption({ ...option, content: e.target.value })
                    }}
                />
                <input
                    type="text"
                    id="sms"
                    placeholder="Kod SMS"
                    className={styles.AddCathegory__formInput}
                    value={option.smsCode}
                    onChange={(e) => {
                        setOption({ ...option, smsCode: e.target.value });
                    }}
                />
                {/* <input
                    type="text"
                    id="image"
                    placeholder="Link do obrazu"
                    className={styles.AddCathegory__formInput}
                    value={option.image}
                    onChange={(e) => {
                        setOption({ ...option, image: e.target.value?.includes('https:') ? e.target.value.slice(6) : e.target.value })
                    }}
                />
                <input
                    type="text"
                    id="file"
                    placeholder="Link do pliku"
                    className={styles.AddCathegory__formInput}
                    value={option.file}
                    onChange={(e) => {
                        setOption({ ...option, file: e.target.value?.includes('https:') ? e.target.value.slice(6) : e.target.value })
                    }}
                /> */}
                <label htmlFor="image">Obraz JPG lub PNG:</label>
                <input
                    type="file"
                    id="image"
                    name="image"
                    accept="image/png, image/jpeg"
                    className={styles.AddCathegory__formInput}
                    onChange={(e) => {
                        let image = e.target.files![0];
                        setOption({ ...option, image: image })
                    }}
                />
                <label htmlFor="audio">Plik MP3:</label>
                <input
                    type="file"
                    id="audio"
                    name="audio"
                    accept="audio/mpeg"
                    className={styles.AddCathegory__formInput}
                    onChange={(e) => {
                        let audio = e.target.files![0];
                        setOption({ ...option, file: audio })
                    }}
                />
                <div className={styles.addPoll__row}>
                    <Select
                        placeholder={"Wybierz tag*"}
                        value={selectedTag}
                        onChange={(e) => {
                            setSelectedTag(e)
                        }}
                        options={tagArr}
                        className={styles.editSelect}
                        styles={customStyles}
                    />
                </div>
                {!loading ? <input
                    type="button"
                    value="EDYTUJ"
                    className={styles.AddCathegory__button}
                    onClick={(e) => {
                        e.preventDefault();
                        setLoading(true);
                        editOption();
                        API.getListOfPollOptions(pollId).then((res) => {
                            setOptions(res?.data.data);
                        })
                    }}
                /> : <p className={styles.loader}>Trwa dodawanie...</p>
                }
                {error &&
                    <div className={styles.addPoll__row}>
                        <p className={styles.errorText}>{error}</p>
                    </div>
                }
            </form>
        </div>
    )
}

export default EditOptionModal;